// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".notification-close-icon[data-v-77978181]{width:18px;height:18px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
